'use client'

import { useEffect } from 'react'

/**
 * Opens the disclosure a fragment points at - browsers do not expand a closed <details> on fragment
 * navigation, so a shared link to a cookie category lands on a collapsed row.
 *
 * Renders null, so the rows stay server-rendered. A Cookie inventory is 146 of them.
 */
export const OpenTargetedDetails: React.FC = () => {
  useEffect(() => {
    const reveal = () => {
      const id = decodeURIComponent(window.location.hash.slice(1))
      if (!id) return

      const target = document.getElementById(id)
      const details = target?.closest('details') as HTMLDetailsElement | null
      if (!target || !details || details.open) return

      details.open = true
      // The browser scrolled while it was closed, and expanding it moves everything below.
      target.scrollIntoView({ block: 'start' })
    }

    reveal()
    window.addEventListener('hashchange', reveal)
    return () => window.removeEventListener('hashchange', reveal)
  }, [])

  return null
}
